import React, {useState} from 'react'
import {FaBars, FaTimes, FaGithub, FaLinkedin} from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import Logo from '../assets/sm.png'
import {Link} from 'react-scroll'

const Navbar = () => {
    const [nav, setNav] = useState(false)
    const handleClick = () => setNav(!nav);
  return (
    <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#14213d] text-[#00a8e8] font-bold z-50'>
        <div>
            <img src={Logo} alt="Logo Image" style={{width: '50px'}}/>
        </div>

        {/* menu */}
            <ul className='hidden md:flex z-50'>
                <li><Link to="home" smooth={true} duration={500}>Home</Link></li>
                <li><Link to="about" smooth={true} duration={500}>About</Link></li>
                <li><Link to="skills" smooth={true} duration={500}>Skills</Link></li>
                <li><Link to="projects" smooth={true} duration={500}>Projects</Link></li>
            </ul>

        {/* hamburger */}
        <div onClick={handleClick} className='md:hidden'>
            {!nav ? <FaBars /> : <FaTimes />}
        </div>

            
            {/* mobile menu */}
            <ul className={!nav ? 'hidden' : 'absolute top-0 left-0 w-full h-screen bg-[#14213d] flex flex-col justify-center items-center'}>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to="home" smooth={true} duration={500}>Home</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to="about" smooth={true} duration={500}>About</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to="skills" smooth={true} duration={500}>Skills</Link></li>
                <li className='py-6 text-4xl'><Link onClick={handleClick} to="projects" smooth={true} duration={500}>Projects</Link></li>
            </ul>
            {/* social icons */}
            <div className='hidden lg:flex fixed flex-col top-[35%] left=0'>
                <ul>
                    <li className='w-[140px] h-[60px] flex jusitfy-between items-center ml-[-100px] hover:ml-[-20px] duration-300 bg-blue-600'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://www.linkedin.com/in/shriraj-m/" target='_blank'>
                            Linkedin <FaLinkedin size={30}/>
                        </a>
                    </li>

                    <li className='w-[140px] h-[60px] flex jusitfy-between items-center ml-[-100px] hover:ml-[-20px] duration-300 bg-gray-800'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://www.github.com/shriraj-m" target='_blank'>
                            Github <FaGithub size={30}/>
                        </a>
                    </li>

                    {/* <li className='w-[140px] h-[60px] flex jusitfy-between items-center ml-[-100px] hover:ml-[-20px] duration-300 bg-green-600'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="/">
                            Email <HiOutlineMail size={30}/>
                        </a>
                    </li> */}

                    <li className='w-[140px] h-[60px] flex jusitfy-between items-center ml-[-100px] hover:ml-[-20px] duration-300 bg-red-400'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://drive.google.com/file/d/184cXpp-FjTvn3GnObRHinRqe2eLvXrx3/view?usp=sharing" target='_blank'>
                            Resume <BsFillPersonLinesFill size={30}/>
                        </a>
                    </li>



                </ul>
            </div>        
    </div>
  )
}

export default Navbar